import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=7eea58f2&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=7eea58f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eea58f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eea58f2')) {
      api.createRecord('7eea58f2', component.options)
    } else {
      api.reload('7eea58f2', component.options)
    }
    module.hot.accept("./PaginationComponent.vue?vue&type=template&id=7eea58f2&scoped=true", function () {
      api.rerender('7eea58f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/PaginationComponent.vue"
export default component.exports